import React from 'react';
import { SvgIcon } from '@scotia/canvas-react';
import styles from './IlustrativeIcons.scss';

export const MailIcon = () => (
  <svg width="22" height="18" viewBox="0 0 22 18">
    <g transform="translate(-1 -3)" fill="none">
      <polygon points="0 0 24 0 24 24 0 24" />
      <g transform="translate(1.333 4)" stroke="#333">
        <path d="M18.8817912,0.686591143 C19.8817912,0.686591143 20.699973,1.51141597 20.699973,2.51750086 L20.699973,13.5029591 C20.699973,14.5108749 19.8817912,15.3338689 18.8817912,15.3338689 L2.51815481,15.3338689 C1.51815481,15.3338689 0.699972995,14.5108749 0.699972995,13.5029591 L0.699972995,2.51750086 C0.699972995,1.51141597 1.51815481,0.686591143 2.51815481,0.686591143 L18.8817912,0.686591143 Z" />
        <polyline points="20.3095703 1.61729601 10.9658703 8.92586795 1.38370662 1.32850809" />
      </g>
    </g>
  </svg>
);

export const Talking = () => (
  <svg width="38px" height="26px" viewBox="0 0 38 26" version="1.1">
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
    >
      <g transform="translate(-199.000000, -1042.000000)">
        <g transform="translate(182.000000, 1021.000000)">
          <g transform="translate(18.000000, 22.000000)">
            <g stroke-linejoin="round">
              <path
                d="M24.2307692,6.92307692 C26.4207902,6.92307692 28.1971259,8.69941259 28.1971259,10.8881119 C28.1971259,13.0768112 26.4207902,14.8531469 24.2307692,14.8531469"
                stroke="#575700"
              />
              <path
                d="M14.5384615,15.8601399 L14.3626783,15.8601399 L12.8638951,15.8601399 L1.32167832,15.8601399 C0.594755245,15.8601399 0,15.2653846 0,14.5384615 L0,6.60839161 C0,5.88146853 0.594755245,5.28671329 1.32167832,5.28671329 L13.2167832,5.28671329 L14.3626783,5.28671329 L14.1855734,5.28671329"
                stroke="#575700"
              />
              <path d="M4.8,23.7902098 L4.8,5.28671329" stroke="#BE207A" />
              <polyline
                stroke="#575700"
                points="14.5384615 15.8601399 23.7902098 21.1468531 23.7902098 0 14.5384615 5.28671329"
              />
            </g>
            <path
              d="M31.1538462,14.5384615 L32.4122345,15.8090668"
              stroke="#F5C400"
              stroke-linejoin="round"
            />
            <path
              d="M31.1538462,5.73280682 L32.7068515,4.84615385"
              stroke="#F5C400"
              stroke-linejoin="round"
            />
            <path d="M32.8846154,10.2 L35.6538462,10.2" stroke="#F5C400" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const PrintIconColored = () => (
  <SvgIcon
    className={styles['hover-svg-color-change']}
    color="highlight"
    iconType="svg-icon"
    color={'inherit'}
  >
    <defs>
      <polygon points="0 15.6666667 16 15.6666667 16 0 0 0" />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-661.000000, -625.000000)">
        <g transform="translate(578.000000, 610.000000)">
          <g transform="translate(84.000000, 15.000000)">
            <path
              d="M3.22727273,12.5 L1.18181818,12.5 C0.806818182,12.5 0.5,12.2 0.5,11.8333333 L0.5,5.16666667 C0.5,4.8 0.806818182,4.5 1.18181818,4.5 L14.8181818,4.5 C15.1931818,4.5 15.5,4.8 15.5,5.16666667 L15.5,11.8333333 C15.5,12.2 15.1931818,12.5 14.8181818,12.5 L12.7727273,12.5"
              stroke="#8230DF"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <polygon
              stroke="#8230DF"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="3.33333333 15.5 12.6666667 15.5 12.6666667 9.5 3.33333333 9.5"
            />
            <mask fill="white" />
            <g />
            <polygon
              stroke="#8230DF"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="3.16666667 4.5 12.5 4.5 12.5 0.5 3.16666667 0.5"
            />
            <path
              d="M12.5,6.22222222 L13.1666667,6.22222222"
              stroke="#8230DF"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              mask="url(#mask-2)"
            />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const ContactInfoIcon = () => (
  <svg
    width="67"
    height="62"
    viewBox="0 0 67 62"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(-3 -4)" fill="none">
      <polygon points="0 0 72 0 72 72 0 72" />
      <g transform="translate(5 6)">
        <path
          d="M48,58 L48,50.4055026 C48,44.6587022 42.627417,40 36,40 L12,40 C5.372583,40 1.66470012e-13,44.6587022 1.66470012e-13,50.4055026 L-9.23705556e-14,58"
          stroke="#042F43"
        />
        <circle stroke="#042F43" cx="23" cy="21" r="11" />
        <path d="M44.75,0 L63.8032951,0" id="Stroke-9" stroke="#0B9CE5" />
        <path d="M44.75,8.13559322 L63.8032951,8.13559322" stroke="#0B9CE5" />
        <path d="M44.75,17.6271186 L54.2766476,17.6271186" stroke="#0B9CE5" />
      </g>
    </g>
  </svg>
);

export const ProtectionIcon = () => (
  <svg
    width="25"
    height="31"
    viewBox="0 0 25 31"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none">
      <path
        d="M11.6805556,28.5523528 C0.149833333,24.3570194 0.00886111111,11.1877972 0.00886111111,11.1877972 C0.00402777778,10.7455472 0,10.0197417 0,9.57668611 L0,4.69904722 C0,4.25599167 0.3625,3.89349167 0.805555556,3.89349167 L2.5955,3.89349167"
        stroke="#0B9CE5"
        transform="translate(1 1)"
      />
      <path
        d="M2.59566111,3.89325 C8.84113333,3.89325 11.6501056,0 11.6501056,0"
        stroke="#0B9CE5"
        transform="translate(1 1)"
      />
      <path
        d="M11.6805556,28.5523528 C23.2112778,24.3570194 23.35225,11.1877972 23.35225,11.1877972 C23.3570833,10.7455472 23.3611111,10.0197417 23.3611111,9.57668611 L23.3611111,4.69904722 C23.3611111,4.25599167 22.9986111,3.89349167 22.5555556,3.89349167 L20.7656111,3.89349167"
        stroke="#0B9CE5"
        transform="translate(1 1)"
      />
      <path
        d="M20.76545,3.89325 C14.5199778,3.89325 11.7110056,0 11.7110056,0"
        stroke="#0B9CE5"
        transform="translate(1 1)"
      />
      <path
        d="M11.75,15.5054169 L11.75,9.73376944"
        stroke="#064765"
        transform="translate(1 1)"
      />
      <path
        d="M11.75,19.5054169 L11.75,19.4554169"
        stroke="#064765"
        transform="translate(1 1)"
      />
      <path stroke="#064765" transform="translate(1 1)" />
    </g>
  </svg>
);
